<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 text-xs-left px-3>
        <h2
          style="font-size: 19px !important"
          class="title text-sm-left grey--text text--darken-1 mt-1 mb-4 ml-1 mt-3"
        >
          Lista de mandatos
        </h2>
      </v-flex>
    </v-layout>

    <SyndicationMandateForm
      v-if="!disableFields"
      :editData="editData"
      :syndicationMandateDialogShow="syndicationMandateDialogShow"
      :closeForm="closeForm"
      :openForm="openForm"
      :updateSyndicationMandate="updateSyndicationMandate"
    />

    <v-data-table
      class="mt-3"
      no-data-text="Não há mandatos cadastrados"
      :headers="headers"
      :items="syndicationMandateList"
      rows-per-page-text="Linhas por página"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.reference }}</td>
        <td class="text-xs-center">
          {{ props.item.date_init | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.date_end | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-center layout">
          <template v-if="!disableFields">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <!-- <v-icon
              small
              class="mr-2"
              @click="confirmToogleStatusItem(props.item)"
            >check</v-icon>-->
            <!-- <v-icon small class="mr-2" @click="confirmToogleStatusItem(props.item)">block</v-icon> -->
            <v-icon small @click="confirmDelMandate(props.item)">delete</v-icon>
          </template>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SyndicationMandateForm from './SyndicationMandateForm'

export default {
  name: 'SyndicationMandate',

  components: {
    SyndicationMandateForm
  },

  props: {
    disableFields: { type: Boolean, default: false },
    forwShow: Boolean,
    syndicationMandateList: Array,
    updateSyndicationMandate: Function,
    confirmDelMandate: Function
  },

  data () {
    return {
      // notifySindication: [],
      // alert_date: "1",
      notifySindcationMandate: [],
      // responsibleDialog: false,
      editData: {},
      headers: [
        {
          text: 'Referência',
          value: 'reference',
          align: 'left',
          sortable: false
        },
        {
          text: 'Data inicial',
          value: 'date_init',
          align: 'center',
          sortable: false
        },
        {
          text: 'Data final',
          value: 'date_end',
          align: 'center',
          sortable: false
        },
        { text: 'Ações', value: '', sortable: false, align: 'left' }
      ],
      // syndicationMandateList: [],
      syndicationMandateDialogShow: false,
      mainSyndicationMandate: false
    }
  },

  watch: {
    forwShow (v) {
      if (v) {
        if (this.syndicationMandateList.length) {
          this.mainSyndicationMandate = false
        } else {
          this.mainSyndicationMandate = true
        }
      }
    }
    // syndicationMandateList.length
  },

  methods: {
    updateGrid (data) {
      // this.syndicationMandateList = [...data];
      this.mainSyndicationMandate = false
      this.syndicationMandateDialogShow = false
    },

    editItem (data) {
      data.editing = true
      this.editData = { ...data }
      this.openForm('editing')
    },

    confirmToogleStatusItem () {},

    openForm (edit) {
      if (edit !== 'editing') {
        this.editData = {}
      }
      this.syndicationMandateDialogShow = true
    },

    closeForm (edit) {
      this.mainSyndicationMandate = false
      this.editData = {}
      this.syndicationMandateDialogShow = false
    }
  }
}
</script>

<style>
</style>
